"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableTypeToLocalizedString = exports.createTableTypeCellFormatter = exports.createTextCellFormatter = exports.TextCellFormatter = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const LayoutStyles_1 = require("../../style/LayoutStyles");
const StyleFunctions_1 = require("../../style/StyleFunctions");
const CellStyles_1 = require("./CellStyles");
const PlaceholderTextCell_1 = require("./PlaceholderTextCell");
const textCellClass = (0, StyleFunctions_1.cssClass)('textCell', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, { display: 'flex' });
const disabledTextCellClass = (0, StyleFunctions_1.cssClass)('disabledTextCell', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle, CellStyles_1.cellDisabledStyle, { display: 'flex' });
const noPaddingTextCellClass = (0, StyleFunctions_1.cssClass)('noPaddingTextCell', LayoutStyles_1.elideTextStyle, { display: 'flex' });
const textContainerClass = (0, StyleFunctions_1.cssClass)('textContainerClass', {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
});
const postIconClass = (0, StyleFunctions_1.cssClass)('postIconClass', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '8px',
});
/**
 * Formatter for a text cell, with optional "icon" content aligned to the right.
 * For a cell with a hyperlink and optional icon, use LinkCellFormatter.
 */
function TextCellFormatter(props) {
    var _a;
    let className = textCellClass;
    if (props.disabled) {
        className = disabledTextCellClass;
    }
    else if (props.noPadding) {
        className = noPaddingTextCellClass;
    }
    if (props.text) {
        const title = (_a = props.cellTitle) !== null && _a !== void 0 ? _a : props.text;
        const textWithTooltip = props.useWidgetsTooltip
            ? (react_1.default.createElement(widgets_1.Tooltip, { getContent: () => react_1.default.createElement("span", null, title) },
                react_1.default.createElement("span", null, props.text)))
            : props.text;
        return (react_1.default.createElement("div", { className: className, title: props.useWidgetsTooltip ? undefined : title },
            react_1.default.createElement("div", { className: textContainerClass }, textWithTooltip),
            props.postIcon
                ? react_1.default.createElement("div", { className: postIconClass }, props.postIcon)
                : null));
    }
    else if (props.placeholder) {
        return react_1.default.createElement(PlaceholderTextCell_1.PlaceholderTextCell, { placeholderText: props.placeholder });
    }
    else {
        return react_1.default.createElement("div", { className: props.disabled ? disabledTextCellClass : textCellClass }); // so empty columns select row in connect-to grids
    }
}
exports.TextCellFormatter = TextCellFormatter;
function createTextCellFormatter(getTextFromRowData, placeholder, getDisabledFromRowData, noPadding = false, getPostIconFromRowData, getCellTitleFromRowData) {
    // eslint-disable-next-line react/display-name
    return (props) => (react_1.default.createElement(TextCellFormatter, { text: getTextFromRowData(props.row.data), cellTitle: getCellTitleFromRowData
            ? getCellTitleFromRowData(props.row.data)
            : getTextFromRowData(props.row.data), postIcon: getPostIconFromRowData ? getPostIconFromRowData(props.row.data) : null, placeholder: placeholder, disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, noPadding: noPadding }));
}
exports.createTextCellFormatter = createTextCellFormatter;
function createTableTypeCellFormatter(tableTypePropName, getDisabledFromRowData) {
    return createTextCellFormatter((rowData) => {
        return getTableTypeToLocalizedString(rowData[tableTypePropName]);
    }, undefined, getDisabledFromRowData);
}
exports.createTableTypeCellFormatter = createTableTypeCellFormatter;
function getTableTypeToLocalizedString(tableType) {
    switch (tableType) {
        case 'DatabaseTable':
            return catalog_messages_1.Messages.Table();
        case 'DATAMODEL':
        case 'DataModel':
            return catalog_messages_1.Messages.DataModelObject();
        case 'DATALAKE':
        case 'DataLake':
            return catalog_messages_1.Messages.DataLakeObject();
        case 'CALCULATEDINSIGHT':
        case 'CalculatedInsight':
            return catalog_messages_1.Messages.CalculatedInsight();
        default:
            return catalog_messages_1.Messages.Table();
    }
}
exports.getTableTypeToLocalizedString = getTableTypeToLocalizedString;
//# sourceMappingURL=TextCellFormatter.js.map